const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;

export const refreshIdToken = async () => {
  const refreshToken = localStorage.getItem('firebase_refresh_token');
  if (!refreshToken) return;

  const response = await fetch(
    `https://securetoken.googleapis.com/v1/token?key=${API_KEY}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      }),
    }
  );

  const data = await response.json();
  if (!response.ok)
    throw new Error(data.error?.message || 'Token refresh failed');

  const expiresAt = Date.now() + 55 * 60 * 1000; // 55 minutes

  localStorage.setItem('firebase_id_token', data.id_token);
  localStorage.setItem('firebase_refresh_token', data.refresh_token);
  localStorage.setItem('firebase_token_expires_at', expiresAt.toString());

  return data.id_token;
};

export const getValidIdToken = async () => {
  const idToken = localStorage.getItem('firebase_id_token');
  const refreshToken = localStorage.getItem('firebase_refresh_token');
  const expiresAt = parseInt(
    localStorage.getItem('firebase_token_expires_at') || '0'
  );
  const isExpired = Date.now() >= expiresAt;

  if (!idToken && refreshToken) return await refreshIdToken();

  return isExpired ? await refreshIdToken() : idToken;
};
